// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__KViir","checked":"styles_checked__OeNa6","notice":"styles_notice__SO4qj"};